import Row from "./row";
import Col from "./col";
import React from "react";

interface GridProps {
  items: React.ReactNode[];
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

const Grid = ({ items, xs = 1, sm = 2, md = 3, lg = 4, xl = 5 }: GridProps) => {
  return (
    <Row
      gutter={[16, 16]}
      children={items.map((item, index) => (
        <Col
          key={index}
          children={item}
          xs={24 / xs}
          sm={24 / sm}
          md={24 / md}
          lg={24 / lg}
          xl={24 / xl}
        />
      ))}
    ></Row>
  );
};

export default Grid;
